var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5493 81C47.5493 81 48.4405 66.568 48.4405 65.2312C48.4405 63.8943 49.2204 43.1729 49.2204 41.5018V39.2737C49.2204 39.2737 49.109 37.8816 48.83 37.3236C48.551 36.7657 46.0449 30.1937 46.1001 26.5734C46.1554 22.9532 46.0983 22.7857 46.0992 21.6716C46.1001 20.5575 45.8755 20.2795 46.0992 18.9979C46.3229 17.7163 46.7133 17.5496 46.9361 16.3241C47.1589 15.0987 47.8273 13.4828 48.7747 12.5916C49.7221 11.7004 51.5599 11.8118 52.5073 12.0907C53.4547 12.3697 55.6819 12.7592 56.1275 14.9873C56.5731 17.2154 57.7986 23.0637 58.5784 25.069C59.3583 27.0743 59.86 30.8069 62.9794 30.4165C62.9794 30.4165 65.0961 30.1937 64.7619 28.077",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6079 16.269C48.6079 16.269 49.6667 17.8287 50.279 18.2743C50.8913 18.72 51.6159 19.2208 52.7852 21.2261C53.9545 23.2314 56.1826 28.857 58.5783 28.6342C58.5783 28.6342 59.7618 28.4336 59.5542 27.898",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5493 19.3882C47.5493 19.3882 50.1847 20.4773 52.0697 20.1003",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0244 12.2352C53.0244 12.2352 53.8996 10.3653 56.6295 10.1425C59.3594 9.91971 61.4761 9.13988 61.7542 12.482C62.0322 15.8242 62.9796 21.0041 63.2024 23.3445C63.4252 25.6849 63.8709 28.5244 66.5999 28.3578C69.3288 28.1911 69.3288 25.4675 68.9955 22.4569C68.6622 19.4462 68.4385 16.9392 68.3271 12.4829C68.2157 8.02671 67.2683 6.02141 64.5393 6.24422C64.5393 6.24422 60.3611 6.46703 60.3415 10.0436",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2079 5.96438C65.2079 5.96438 64.9316 1.73007 67.2684 1.67571C69.4422 1.62491 69.4413 4.52413 69.4413 4.52413",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4985 16.9935C70.4985 16.9935 73.0047 17.4391 73.8407 13.8742C74.6767 10.3092 75.2889 9.52934 75.7346 8.24773C76.1802 6.96612 77.6285 2.6222 73.7845 1.22918C69.9406 -0.163834 69.2401 5.20681 69.1447 6.2255C69.0493 7.24419 68.3836 14.3831 68.3836 14.3831C68.3836 14.3831 68.1037 16.7146 70.4985 16.9935Z",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0633 14.4863C74.0633 14.4863 75.8431 18.6752 76.3734 19.7839C76.9037 20.8926 77.1238 22.3961 76.3734 23.6777C75.623 24.9585 72.615 29.0252 71.9466 30.6401C71.2781 32.2551 69.3691 34.4832 68.3745 35.8762C67.3798 37.2692 66.8781 37.4911 66.6553 43.0614C66.4324 48.6317 66.8228 70.8014 68.2149 76.5383L69.329 80.6042",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5625 56.3086H27.8516V80H21.9922V56.3086H13.3984V51.5625H36.5625V56.3086Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 68.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThand);
export default __webpack_public_path__ + "static/media/Thand.eb55380e0021aa5437aa1b6399c4d6b1.svg";
export { ForwardRef as ReactComponent };